import { render, staticRenderFns } from "./MorelineAssort.vue?vue&type=template&id=a5a7c91c&scoped=true&"
import script from "./MorelineAssort.vue?vue&type=script&lang=js&"
export * from "./MorelineAssort.vue?vue&type=script&lang=js&"
import style0 from "./MorelineAssort.vue?vue&type=style&index=0&id=a5a7c91c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a7c91c",
  null
  
)

export default component.exports